import { jsx as _jsx } from "react/jsx-runtime";
import { getTemplate, getUiOptions } from '@rjsf/utils';
export default function TextareaWidget(props) {
    const { uiSchema, registry } = props;
    const options = getUiOptions(uiSchema);
    const BaseInputTemplate = getTemplate('BaseInputTemplate', registry, options);
    // TODO: rows and columns.
    return _jsx(BaseInputTemplate, { ...props, multiline: true });
}
//# sourceMappingURL=TextareaWidget.js.map